// src/styles/ChatStyles.js
import styled, { keyframes } from 'styled-components';

// ... (keyframes spin, typingDotsAnimation - bez zmian)
const typingDotsAnimation = keyframes`
    0%, 20% {
        transform: translateY(0px) scale(0.7);
        opacity: 0.5;
    }
    40% {
        transform: translateY(-4px) scale(1);
        opacity: 1;
    }
    60%, 100% {
        transform: translateY(0px) scale(0.7);
        opacity: 0.5;
    }
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;


export const ChatAppWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.background};
    overflow: hidden;

    .icon-spin {
        animation: ${spin} 1s linear infinite;
    }
`;

export const ConversationsSidebar = styled.aside`
    width: 300px;
    flex-shrink: 0;
    background-color: ${({ theme }) => theme.colors.neutralLight};
    border-right: 1px solid ${({ theme }) => theme.colors.borderColor};
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing.md};
    transition: transform 0.3s ease-in-out;
    z-index: 1000;

    @media (max-width: 768px) {
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        height: 100vh;
        transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(-100%)')};
    }
`;

export const NewChatButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.sm};
    padding: ${({ theme }) => theme.spacing.md};
    margin-bottom: ${({ theme }) => theme.spacing.md};
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    border: none;
    border-radius: ${({ theme }) => theme.borderRadius};
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: background-color 0.2s, box-shadow 0.2s;
    box-shadow: ${({ theme }) => theme.shadows.sm};

    &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.primaryDark};
        box-shadow: ${({ theme }) => theme.shadows.md};
    }
    &:disabled {
        background-color: ${({ theme }) => theme.colors.neutralMedium};
        cursor: not-allowed;
    }
    svg {
        width: 20px;
        height: 20px;
    }
`;

export const ConversationList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    flex-grow: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
`;

export const ConversationListItem = styled.li`
    padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
    border-radius: ${({ theme }) => theme.borderRadius};
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s;
    border: 1px solid transparent;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme }) => theme.shadows.sm};

    .conv-title {
        font-weight: 600;
        color: ${({ theme }) => theme.colors.textDark};
        font-size: 0.9rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: ${({ theme }) => theme.spacing.xs};
    }
    .conv-snippet {
        font-size: 0.8rem;
        color: ${({ theme }) => theme.colors.textMedium};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: ${({ theme }) => theme.spacing.xs};
        height: 1.2em;
    }
    .conv-timestamp {
        font-size: 0.7rem;
        color: ${({ theme }) => theme.colors.textDisabled};
        text-align: right;
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.primaryLightest};
        border-color: ${({ theme }) => theme.colors.primaryLight};
    }

    &.active {
        background-color: ${({ theme }) => theme.colors.primary};
        border-color: ${({ theme }) => theme.colors.primaryDark};
        box-shadow: ${({ theme }) => theme.shadows.md};
        .conv-title {
            color: ${({ theme }) => theme.colors.white};
        }
        .conv-snippet, .conv-timestamp {
            color: ${({ theme }) => theme.colors.primaryLighter};
        }
    }
`;

export const NoConversationsMessage = styled.div`
    text-align: center;
    padding: ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing.lg};
    color: ${({ theme }) => theme.colors.textDisabled};
    font-style: italic;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: ${({ theme }) => theme.spacing.md};

    svg {
        width: 48px;
        height: 48px;
        opacity: 0.7;
    }
`;

export const ChatArea = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    background-color: ${({ theme }) => theme.colors.white};
    overflow: hidden;
`;

export const ChatHeaderStyled = styled.header`
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primaryDark};
    padding: 0 ${({ theme }) => theme.spacing.sm}; /* Zmniejszony padding dla miejsca na ikony */
    height: 60px;
    flex-shrink: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
    display: flex;
    align-items: center;
    justify-content: space-between; /* Główne wyrównanie */
    z-index: 10;

    /* Na desktopie, przyciski po prawej są ukryte */
    .desktop-chat-actions {
        display: none;
    }

    @media (max-width: 768px) {
        padding: 0 ${({ theme }) => theme.spacing.xs}; /* Jeszcze mniejszy padding na mobilkach */
        .desktop-chat-actions {
            display: flex; /* Pokaż akcje na mobilce */
        }
    }
`;

export const ChatHeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xs}; /* Odstęp między ikonami */

    /* Ukrywamy na desktopie, bo MobileChatMenuButton ma własne media query */
    /* Logika widoczności tych przycisków będzie w komponencie React */
`;

// Przycisk do przełączania paska bocznego konwersacji
// (poprzednio MobileChatMenuButton, teraz może być użyty w ChatHeaderActions)
export const ChatSidebarToggleButton = styled.button`
    background: none;
    border: none;
    padding: ${({ theme }) => theme.spacing.sm};
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primaryDark};
    display: inline-flex; /* Aby ikona była dobrze wyśrodkowana */
    align-items: center;
    justify-content: center;

    svg {
        width: 24px;
        height: 24px;
    }
`;


export const ConversationTitle = styled.h2`
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.colors.primaryDarker};
    flex-grow: 1; /* Tytuł zajmuje dostępną przestrzeń */
    text-align: center; /* Wyśrodkowanie tytułu */

    /* Na mobilkach, dajemy tytułowi marginesy, aby nie stykał się z ikonami */
    @media (max-width: 768px) {
        margin: 0 ${({ theme }) => theme.spacing.xs};
        font-size: 1rem; /* Nieco mniejszy tytuł na mobilkach */
    }
`;

export const MessagesList = styled.div`
    flex-grow: 1;
    padding: ${({ theme }) => theme.spacing.md};
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm};
    background-color: ${({ theme }) => theme.colors.background};
    -webkit-overflow-scrolling: touch;
    min-height: 0;
`;

export const MessageItem = styled.div`
    display: flex;
    max-width: 100%;

    ${({ sender }) => sender === 'user' && `
        justify-content: flex-end; 
        max-width: 85%; 
        align-self: flex-end;
    `}

    ${({ sender }) => sender === 'bot' && `
        justify-content: flex-start; 
        align-self: flex-start; 
    `}
`;

export const MessageBubble = styled.div`
    padding: 0.4rem 0.625em;
    border-radius: 0.75rem;
    box-shadow: ${({ theme }) => theme.shadows.sm};
    word-break: break-word;
    font-size: 0.8125rem;
    line-height: 1.45;
    position: relative;
    max-width: 100%;

    ${({ sender, theme }) =>
            sender === 'user'
                    ? `
        background-color: ${theme.colors.primary}; 
        color: ${theme.colors.white};
        border-bottom-right-radius: 0.25rem; 
      `
                    : ` 
        background-color: ${theme.colors.white}; 
        color: ${theme.colors.textDark};
        border: 1px solid ${theme.colors.borderColor};
        border-bottom-left-radius: 0.25rem; 
      `}

    & > *:last-child { margin-bottom: 0; }
    & > p:only-child { margin-bottom: 0; }

    h1, h2, h3, h4, h5, h6 { margin-top: 0.5em; margin-bottom: 0.25em; line-height: 1.2; }
    ul, ol { margin-left: 0; margin-bottom: 0.3em; padding-left: 1.25em; }
    li { margin-bottom: 0.15em; }
    code { font-size: 0.75em; }
    pre { padding: ${({ theme }) => theme.spacing.xs}; font-size: 0.7em; }
    blockquote { padding-left: ${({ theme }) => theme.spacing.sm}; margin: ${({ theme }) => theme.spacing.xs} 0; }
`;

export const TypingIndicatorBubble = styled(MessageBubble)`
    width: fit-content;
    padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md} !important;
    align-self: flex-start;
    display: flex;
    align-items: center;

    span {
        width: 0.5rem;
        height: 0.5rem;
        background-color: ${({ theme }) => theme.colors.textMedium};
        border-radius: 50%;
        animation: ${typingDotsAnimation} 1.2s infinite ease-in-out;
        margin: 0 2px;

        &:nth-child(1) { animation-delay: 0s; }
        &:nth-child(2) { animation-delay: 0.2s; }
        &:nth-child(3) { animation-delay: 0.4s; }
    }
`;

export const ChatInputArea = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    padding: ${({ theme }) => theme.spacing.sm};
    border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
    display: flex;
    align-items: flex-end;
    gap: ${({ theme }) => theme.spacing.sm};
    flex-shrink: 0;
    z-index: 10;
`;

export const ChatTextarea = styled.textarea`
    flex-grow: 1;
    padding: 0.5rem 0.875rem;
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    border-radius: 1rem;
    resize: none;
    min-height: 40px;
    max-height: 100px;
    overflow-y: auto;
    font-size: 0.8125rem;
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.textDark};
    background-color: ${({ theme }) => theme.colors.background};

    &::placeholder { color: ${({ theme }) => theme.colors.textDisabled}; }
    &:focus {
        background-color: ${({ theme }) => theme.colors.white};
        border-color: ${({ theme }) => theme.colors.primary};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primaryLightest};
    }
`;

export const SendButton = styled.button`
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: ${({ theme }) => theme.shadows.sm};
    flex-shrink: 0;
    padding: 0;
    transition: background-color 0.2s, transform 0.1s;
    display: flex;
    align-items: center;
    justify-content: center;

    svg { width: 18px; height: 18px; }

    &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.primaryDark};
        transform: translateY(-1px) scale(1.05);
    }
    &:active:not(:disabled) { transform: scale(0.95); }
    &:disabled {
        background-color: ${({ theme }) => theme.colors.neutralMedium};
        opacity: 0.7;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
`;

export const MobileConversationsOverlay = styled.div`
    display: none;
    @media (max-width: 768px) {
        &.open {
            display: block;
            position: fixed;
            inset: 0;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 999;
        }
    }
`;

// Usunięto MobileChatMenuButton stąd, bo jego rolę przejmie ChatSidebarToggleButton lub będzie częścią LayoutStyles
// Jeśli MobileChatMenuButton był specyficzny tylko dla Chat.js i różnił się od tego z LayoutStyles,
// to jego styl można przenieść do ChatSidebarToggleButton lub podobnego.
// W tym przypadku ChatSidebarToggleButton jest nowym, bardziej generycznym przyciskiem.